import { render } from "./request-basic-fields.vue?vue&type=template&id=d1c5b5c8&scoped=true"
import script from "./request-basic-fields.vue?vue&type=script&lang=js"
export * from "./request-basic-fields.vue?vue&type=script&lang=js"

import "./request-basic-fields.vue?vue&type=style&index=0&id=d1c5b5c8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1c5b5c8"]])

export default __exports__